import { Link } from 'react-router-dom';

// Vector logo recreation of the STAGE CREW community logo (thin rectangle frame,
// bold oblique display type, "STAGE" top-left and "CREW" bottom-right offset).
// Rendered as inline SVG for infinite quality at any size.
export const StageCrewLogo = ({ size = 'md', asLink = true, className = '', onClick }) => {
  const heights = { sm: 28, md: 36, lg: 56, xl: 88 };
  const h = heights[size] || heights.md;
  const svg = (
    <svg
      viewBox="0 0 200 100"
      height={h}
      role="img"
      aria-label="Stage Crew"
      className={className}
      style={{ display: 'block' }}
    >
      {/* Thin rectangle frame */}
      <rect
        x="4" y="4" width="192" height="92"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
      />
      {/* Wordmark — bold oblique display */}
      <text
        x="18" y="46"
        fill="currentColor"
        style={{
          fontFamily: "'Outfit', 'Arial Black', sans-serif",
          fontWeight: 900,
          fontStyle: 'italic',
          fontSize: '34px',
          letterSpacing: '-0.02em',
        }}
      >STAGE</text>
      <text
        x="72" y="82"
        fill="currentColor"
        style={{
          fontFamily: "'Outfit', 'Arial Black', sans-serif",
          fontWeight: 900,
          fontStyle: 'italic',
          fontSize: '34px',
          letterSpacing: '-0.02em',
        }}
      >CREW</text>
    </svg>
  );

  if (!asLink) return svg;
  return (
    <Link to="/" onClick={onClick} data-testid="brand-logo" className={`inline-flex items-center text-white hover:text-amber-500 transition-colors ${className}`}>
      {svg}
    </Link>
  );
};

export default StageCrewLogo;
